import React, { useState, useEffect } from "react";
import { Table, Button, Pagination, message } from "antd";
import ChallengeDetail from "../pages/ChallengeDetail";
import CreateChallengeModal from "../pages/CreateChallengeModal";
import { binaryContentsHooks as cHooks } from "../hooks";
const ChallengeLayout = () => {
  const [challenges, setChallenges] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [selectedChallenge, setSelectedChallenge] = useState(null);
  const [isDetailModalVisible, setIsDetailModalVisible] = useState(false);
  const [isCreateModalVisible, setIsCreateModalVisible] = useState(false);

  const fetchChallenges = async (currentPage = 1) => {
    setLoading(true);
    try {
      const response = await cHooks.challengeList({ page: currentPage });
      const { data, cnt } = response.data;
      setChallenges(data);
      setTotal(cnt);
    } catch (error) {
      console.error("챌린지 데이터를 가져오는 중 오류가 발생했습니다.", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      const res = await cHooks.challengeDelete({ id: id });
      if (res.IsError) {
        throw new Error("delete challenge error");
      }
      message.success("챌린지가 삭제되었습니다.");
      fetchChallenges(page);
      setIsDetailModalVisible(false);
    } catch (error) {
      console.error("챌린지 삭제 중 오류가 발생했습니다.", error);
      message.error("챌린지 삭제에 실패했습니다.");
    }
  };

  const handleUpdate = async (updatedData) => {
    try {
      const res = await cHooks.challengeUpdate({
        challengeAuthCnt: updatedData.challenge_auth_cnt,
        challengeAuthDescription: updatedData.challenge_auth_description,
        id: updatedData.id,
        challengeCertification: updatedData.challenge_certification,
        challengeDaily: updatedData.challenge_daily,
        challengeDescription: updatedData.challenge_description,
        challengeEnd: updatedData.challenge_end,
        challengeFrequency: updatedData.challenge_frequency,
        challengeIcon: updatedData.challenge_icon,
        challengeMax: updatedData.challenge_max,
        challengeStart: updatedData.challenge_start,
        challengeTitle: updatedData.challenge_title,
        ChallengeWeeklyAuth: updatedData.challenge_weekly_auth,
        IsPrivate: updatedData.is_private,
      });
      if (res.IsError) {
        throw new Error("update challenge error");
      }
      message.success("챌린지가 수정되었습니다.");
      fetchChallenges(page);
      setIsDetailModalVisible(false);
    } catch (error) {
      console.error("챌린지 수정 중 오류가 발생했습니다.", error);
      message.error("챌린지 수정에 실패했습니다.");
    }
  };

  const handleCreate = async (newChallenge) => {
    try {
      const res = await cHooks.challengeCreate({
        challengeAuthCnt: newChallenge.challenge_auth_cnt,
        challengeAuthDescription: newChallenge.challenge_auth_description,
        challengeCertification: newChallenge.challenge_certification,
        challengeDaily: newChallenge.challenge_daily,
        challengeDescription: newChallenge.challenge_description,
        challengeEnd: newChallenge.challenge_end,
        challengeFrequency: newChallenge.challenge_frequency,
        challengeIcon: newChallenge.challenge_icon,
        challengeMax: newChallenge.challenge_max,
        challengeStart: newChallenge.challenge_start,
        challengeTitle: newChallenge.challenge_title,
        ChallengeWeeklyAuth: newChallenge.challenge_weekly_auth,
        IsPrivate: newChallenge.is_private,
        challengeType: newChallenge.challenge_type, 
        challengeWeek: newChallenge.challenge_week,
      });
      if (res.IsError) {
        throw new Error("create challenge error");
      }
      message.success("새 챌린지가 생성되었습니다.");
      fetchChallenges(page);
      setIsCreateModalVisible(false);
    } catch (error) {
      console.log(error)
      console.error("챌린지 생성 중 오류가 발생했습니다.", error);
      message.error("챌린지 생성에 실패했습니다.");
    }
  };

  useEffect(() => {
    fetchChallenges(page);
  }, [page]);

  const columns = [
    { title: "챌린지 제목", dataIndex: "challenge_title" },
    { title: "챌린지 인증방식", dataIndex: "challenge_certification" },
    { title: "인증 빈도", dataIndex: "challenge_frequency" },
    {
      title: "주최자",
      render: (record) =>
        record.grade === "admin" ? "관리자" : record.user_name,
    },
    { title: "참여 인원", dataIndex: "challenge_participation" },
    { title: "시작일자", dataIndex: "challenge_start" },
    { title: "종료일자", dataIndex: "challenge_end" },
    {
      title: "상세보기",
      render: (record) => (
        <Button
          type="link"
          onClick={() => {
            setSelectedChallenge(record);
            setIsDetailModalVisible(true);
          }}
        >
          상세 보기
        </Button>
      ),
    },
  ];

  return (
    <div>
      <div
        style={{
          marginBottom: "20px",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Button type="primary" onClick={() => setIsCreateModalVisible(true)}>
          챌린지 생성하기
        </Button>
      </div>
      <Table
        columns={columns}
        dataSource={challenges}
        rowKey="id"
        loading={loading}
        pagination={false}
      />
      <Pagination
        current={page}
        total={total}
        pageSize={10}
        onChange={(page) => setPage(page)}
        style={{ marginTop: 20, textAlign: "center" }}
      />
      {isDetailModalVisible && selectedChallenge && (
        <ChallengeDetail
          visible={isDetailModalVisible}
          onClose={() => setIsDetailModalVisible(false)}
          challenge={selectedChallenge}
          onDelete={handleDelete}
          onUpdate={handleUpdate}
        />
      )}
      {isCreateModalVisible && (
        <CreateChallengeModal
          visible={isCreateModalVisible}
          onClose={() => setIsCreateModalVisible(false)}
          onCreate={handleCreate}
        />
      )}
    </div>
  );
};

export default ChallengeLayout;
